import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPublicKb } from '../services/customerApi';
import { useLanguage } from '../i18n/LanguageContext';

/**
 * Nel modulo del portale: mentre il cliente scrive l'oggetto propone gli articoli di aiuto pubblici che potrebbero
 * già risolvere il problema (si apre in una nuova scheda, così il modulo non si perde). Non compare se non ci sono articoli.
 */
function PortalKbSuggestions({ slug, text }) {
  const { t } = useLanguage();
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const query = (text || '').trim();
    if (query.length < 4) {
      setArticles([]);
      return undefined;
    }
    const timer = setTimeout(() => {
      getPublicKb(slug, query.split(/\s+/).slice(0, 4).join(' ')).then((d) => setArticles((d.articles || []).slice(0, 4))).catch(() => setArticles([]));
    }, 500);
    return () => clearTimeout(timer);
  }, [slug, text]);

  if (articles.length === 0) return null;
  return (
    <div className="portal-kb">
      <strong>{t('portal.kbTitle')}</strong>
      <ul>
        {articles.map((a) => (
          <li key={a.id}>
            <Link to={`/portal/${slug}/help/${a.id}`} target="_blank" rel="noreferrer">{a.title}</Link>
            {a.excerpt && <span className="portal-kb-excerpt"> — {a.excerpt}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PortalKbSuggestions;
